import { Component } from '@angular/core';
import { fadeInAnimation } from 'app/animations';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { SCMaterial, StockCountCreateOrder, StockCountState, TOOrder, TOstockCount } from 'app/core/store/stock-count/stock-count.interface';
import { BaseContainer } from '../../base/BaseContainer';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'stock-count-create',
  templateUrl: './stock-count-create.container.html',
  styleUrls: ['./stock-count-create.container.scss'],
  animations: [fadeInAnimation],
})
export class StockCountLocationContainer extends BaseContainer {
  shipTos: Definition[] = [];
  fullShipTos: Definition[] = [];
  stockCountOrders: StockCountCreateOrder[];
  definitions: Definitions;
  materials: SCMaterial[];

  isSaving: boolean = false;

  selectedShipTo: string = null;
  selectedOrders: StockCountCreateOrder[] = [];

  constructor(public sandbox: StockCountSandbox) {
    super();


    this.store
      .select('customerInfo')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((customerInfo: CustomerInfo) => ({
          shipTos: customerInfo.customer ? customerInfo.customer.shipTos : null,
          customerNr: customerInfo.customer ? customerInfo.customer.id : null,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ shipTos, customerNr }) => {
        if (shipTos && customerNr) {
          this.fullShipTos = shipTos;
          this.sandbox.getShipTos(customerNr);
        }
      });

    this.store
      .select('definitions')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((def: Definitions) => ({
          def,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ def }) => {
        this.definitions = def;
      });

    this.store
      .select('stockCount')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((stockCount: StockCountState) => ({
          orders: stockCount.orders,
          materials: stockCount.materials,
          shipTos: stockCount.shipTos.data,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ orders, materials, shipTos }) => {
        this.stockCountOrders = orders;
        this.materials = materials;
        this.shipTos = shipTos;
      });
  }

  selectedShipToUpdated(shiptoId: string) {
    this.selectedShipTo = shiptoId;
  }

  goToCounts(orderObj: { selectedOrders: StockCountCreateOrder[] }) {
    this.selectedOrders = orderObj.selectedOrders;
    const toOrders: TOOrder[] = [];
    this.selectedOrders.map(o => {
      toOrders.push({
        etmOrderNo: o.etmOrderNo,
        includedInCount: o.includedInCount,
        salesOrderNo: o.salesOrderNo,
      });
    });
    this.sandbox.getStockCountMaterials({
      order: toOrders,
      shipTo: this.selectedShipTo,
    });
  }

  createStockCount(counts: { materialList: SCMaterial[]; comment: string }) {
    const mappedList: TOstockCount = {
      shipTo: this.selectedShipTo,
      order: this.selectedOrders,
      item: counts.materialList,
      comments: counts.comment,
    };
    this.sandbox.createStockCount(mappedList);
  }

  backClicked() {
    this.sandbox.cancelCreate();
  }
}
